import React from 'react';
import appStoreQr from '../assets/images/App Stroe QR.png';
import './AppStoreQrHover.css';

interface AppStoreQrHoverProps {
  children: React.ReactNode;
  /** Where the bubble opens relative to the trigger. */
  placement?: 'top' | 'bottom';
  /** Extra class on the wrapper if a call site needs layout tweaks. */
  className?: string;
}

/**
 * Wraps an App Store CTA and reveals a QR-code bubble on hover/focus.
 * Desktop only — the bubble is fully hidden (and the wrapper is layout-neutral
 * via `display: contents`) below the desktop breakpoint, so mobile is untouched.
 */
const AppStoreQrHover: React.FC<AppStoreQrHoverProps> = ({
  children,
  placement = 'bottom',
  className,
}) => (
  <span
    className={`app-store-qr-hover app-store-qr-hover--${placement}${
      className ? ` ${className}` : ''
    }`}
  >
    {children}
    <span className="app-store-qr-bubble" role="tooltip" aria-hidden="true">
      <img
        src={appStoreQr}
        alt=""
        className="app-store-qr-bubble__img"
        width={140}
        height={140}
      />
      <span className="app-store-qr-bubble__label">Scan to download on your phone</span>
    </span>
  </span>
);

export default AppStoreQrHover;
